import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

export function useLocales(variables) {
  const { loading, error, data } = useQuery(gql`
      query LocalesInfo($source: String){
        locales(source: $source)
      }
      `,
      {
        variables
      }
  );
  return { loading, error, data };
}

export default useLocales;
